import angular from 'angular';
import '../../shared.module';
import template from './table.component.html';
import './table.component.scss';

class TableController {
  cellValue(row, column) {
    return column.key.split('.').reduce((acc, key) => (acc ? acc[key] : undefined), row);
  }
}

angular.module('app.shared').component('cpTable', {
  bindings: {
    columns: '<',
    rows: '<',
    loading: '<',
    emptyLabel: '@'
  },
  controller: TableController,
  controllerAs: 'vm',
  template
});
